// extracted by mini-css-extract-plugin
export default {"book":"ListBooking_book__5-gfV"};